import { render } from "./AudioComponent.vue?vue&type=template&id=05822454&scoped=true"
import script from "./AudioComponent.vue?vue&type=script&lang=js"
export * from "./AudioComponent.vue?vue&type=script&lang=js"

import "./AudioComponent.vue?vue&type=style&index=0&id=05822454&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05822454"]])

export default __exports__